export default __webpack_public_path__ + "static/media/logo.e3ef6fc7.svg";